module.exports = __webpack_public_path__ + "static/media/logo.ddc9fb79.png";